'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _style = require('styled-jsx/style');

var _style2 = _interopRequireDefault(_style);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _StatsTable = require('./StatsTable.css');

var _StatsTable2 = _interopRequireDefault(_StatsTable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var alignmentLabel = function alignmentLabel(alignment, homeTeam, awayTeam) {
  var label = alignment === 'home' ? 'vs' : '@';
  var opponent = alignment === 'home' ? awayTeam : homeTeam;

  return label + ' ' + opponent;
};

var StatsTable = function StatsTable(props) {
  return _react2.default.createElement(
    'table',
    {
      className: 'jsx-' + _StatsTable2.default.__scopedHash + ' ' + 'table'
    },
    _react2.default.createElement(
      'tbody',
      {
        className: 'jsx-' + _StatsTable2.default.__scopedHash
      },
      _react2.default.createElement(
        'tr',
        {
          className: 'jsx-' + _StatsTable2.default.__scopedHash
        },
        _react2.default.createElement(
          'th',
          {
            className: 'jsx-' + _StatsTable2.default.__scopedHash
          },
          props.gameDate
        ),
        props.stats.map(function (stat) {
          return _react2.default.createElement(
            'th',
            { key: stat.label, className: 'jsx-' + _StatsTable2.default.__scopedHash
            },
            stat.label
          );
        })
      ),
      _react2.default.createElement(
        'tr',
        {
          className: 'jsx-' + _StatsTable2.default.__scopedHash
        },
        _react2.default.createElement(
          'td',
          {
            className: 'jsx-' + _StatsTable2.default.__scopedHash
          },
          alignmentLabel(props.alignment, props.homeTeam, props.awayTeam)
        ),
        props.stats.map(function (stat) {
          return _react2.default.createElement(
            'td',
            { key: stat.label, className: 'jsx-' + _StatsTable2.default.__scopedHash
            },
            stat.stat
          );
        })
      )
    ),
    _react2.default.createElement(_style2.default, {
      styleId: _StatsTable2.default.__scopedHash,
      css: _StatsTable2.default.__scoped
    })
  );
};

StatsTable.propTypes = {
  alignment: _propTypes2.default.oneOf(['home', 'away']).isRequired,
  awayTeam: _propTypes2.default.string.isRequired,
  homeTeam: _propTypes2.default.string.isRequired,
  gameDate: _propTypes2.default.string.isRequired,
  stats: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    label: _propTypes2.default.string.isRequired,
    stat: _propTypes2.default.string.isRequired
  })).isRequired
};

exports.default = StatsTable;